import React from 'react';
import PropTypes from 'prop-types';

import MartyLink from 'components/common/MartyLink';
import RewardsProgress from 'components/account/Rewards/RewardsProgress';
import styles from 'styles/components/account/rewardsOverview.scss';

const RewardsOverview = ({ rewards, onRewardsEnrollClick }, { testId }) => {
  const { rewardsInfo } = rewards;

  if (!rewardsInfo) {
    return null;
  }

  const { enrolled, consented, canEnroll } = rewardsInfo;

  if (enrolled && consented) {
    return (
      <div className={styles.rewardsOverview}>
        <h2>Your Rewards</h2>
        <div className={styles.progressContainer}>
          <div>
            <RewardsProgress rewardsInfo={rewardsInfo} size={250}/>
          </div>
          <div>
            <p>
              Thank You for being our rewards member,
              you're doing great! To redeem your points
              and see other ways to redeem more points,
              visit Your Dashboard.
            </p>
            <div>
              <MartyLink to="/rewards/dashboard" data-test-id={testId('rewardsDashboard')}>My Rewards Dashboard</MartyLink>
            </div>
          </div>
        </div>
      </div>
    );
  } else if (!canEnroll) {
    return null;
  } else {
    const termsLink = (
      <a
        href="/rewards-terms-of-use"
        data-track-action="Action"
        data-track-label="Loyalty"
        data-track-value="TermsAndConditions">
        Terms &amp; Conditions
      </a>
    );
    return (
      <div className={styles.rewardsEnroll}>
        <h2>Your Rewards</h2>
        <div className={styles.signup}>
          <input
            type="radio"
            id="rewardsEnroll"
            onClick={onRewardsEnrollClick}/>
          <label htmlFor="rewardsEnroll">
            <div className={styles.labelContainer}>
              <div>YES! Sign me up for Zappos Rewards! I agree to the {termsLink}.</div>
              <div>Earn points, cool swag, and supercharged service!</div>
            </div>
          </label>
        </div>
        <MartyLink
          to="/zappos-rewards"
          className={styles.learnMore}
          data-track-action="Action"
          data-track-label="Loyalty"
          data-track-value="LearnMore">
          More About Zappos Rewards
        </MartyLink>
      </div>
    );
  }
};

RewardsOverview.contextTypes = {
  testId: PropTypes.func
};

RewardsOverview.propTypes = {
  rewards: PropTypes.object,
  onRewardsEnrollClick: PropTypes.func.isRequired
};

export default RewardsOverview;
